import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { createGlobalStyle, css } from 'styled-components';
var getGlobalStyle = function getGlobalStyle(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), props.css);
};
var BaseGlobalStyle = createGlobalStyle(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), getGlobalStyle);
export default BaseGlobalStyle;